export default __webpack_public_path__ + "static/media/phone.74abf791.png";